import { eventEmitter } from '../../common/baseData'

class ViewedProductsSlider {
  init () {
    const viewedProductsWrappers = document.querySelectorAll('.viewed_products_js')

    viewedProductsWrappers.forEach((viewedProductsWrapper, index) => {
      if (!(viewedProductsWrapper instanceof HTMLElement) ||
        viewedProductsWrapper.dataset.actionsHandled) return

      eventEmitter.emit('handleWishlistItems', {
        node: viewedProductsWrapper.querySelectorAll('[data-container="favorite"]'),
        range: `viewed-${index}`
      })

      eventEmitter.emit('handleCompareItems', {
        node: viewedProductsWrapper.querySelectorAll('[data-container="compare"]'),
        range: `viewed-${index}`
      })

      const updateBasketButtons = () => {
        const basketItemsMap = JSON.parse(localStorage.getItem('basketItemsMap')) || {}

        viewedProductsWrapper.querySelectorAll(
          '[data-container="buy"][data-use="order"][data-product-id]'
        ).forEach(button => {
          const inBasket = basketItemsMap.hasOwnProperty(button.dataset.productId)
          const basketIcon = button.querySelector('[data-show="basket"]')
          const inBasketIcon = button.querySelector('[data-show="in-basket"]')

          button.classList.toggle('in-basket', inBasket)
          if (basketIcon) basketIcon.style.display = inBasket ? 'none' : ''
          if (inBasketIcon) inBasketIcon.style.display = inBasket ? '' : 'none'
        })
      }

      viewedProductsWrapper.addEventListener('click', event => {
        const button = event.target.closest('[data-container="buy"][data-product-id]')
        if (!(button instanceof HTMLElement)) return

        event.preventDefault()
        event.stopPropagation()

        const productId = Number(button.dataset.productId)
        if (!productId) return

        if (button.dataset.use === 'order') {
          const basketItemsMap = JSON.parse(localStorage.getItem('basketItemsMap')) || {}

          eventEmitter.emit(
            basketItemsMap.hasOwnProperty(productId) ? 'openSmallCart' : 'addToCart',
            { productId }
          )
        } else if (button.dataset.use === 'pre-order') {
          eventEmitter.emit('preOrder', { productId })
        } else if (button.dataset.use === 'report') {
          eventEmitter.emit('reportAvailability', { productId })
        }
      })

      updateBasketButtons()
      document.body.addEventListener('basketUpdated', updateBasketButtons)
      viewedProductsWrapper.dataset.actionsHandled = 'true'
    })
  }
}

export default ViewedProductsSlider